/*
 * @Autor: zouning@szkingdom.com
 * @Date: 2026-01-16 10:06:39
 * @Description: 应用主题
 * @LastEditors: zouning@szkingdom.com
 */

// import { httpClient } from "@/assets/js/http";
import axios from "axios";

let reqDefault;
const GRAYSCALE_ATTR = "data-grayscale";
function getDefaultCtx() {
    if (!reqDefault) reqDefault = require.context("@/assets/img", true, /\.(png|jpe?g|svg|gif)$/);
    return reqDefault;
}
export function themeImg(path) {
    const name = localStorage.getItem("__THEME__") || "main";
    let img;
    try {
        // 按当前主题查找
        img = require(`@/assets/theme/${name}/images/${path}`);
        return img;
    } catch (e) {
        // 回退到默认主题目录
        try {
            img = require(`@/assets/theme/main/images/${path}`);
            return img;
        } catch (e2) {
            // 再回退到全局图片目录
            const p = `./${path}`;
            const ctx = getDefaultCtx();
            return ctx(p);
        }
    }
}
function loadStyles(url, linkId) {
    const links = document.querySelectorAll("link");
    links.forEach((link) => {
        const id = link.getAttribute("id");
        // mode相同时，版本必定不同，此时删除之前的link，加载新的link
        if (id && id.split("_")[3] === linkId.split("_")[3]) {
            link.parentNode.removeChild(link);
        }
    });
    const link = document.createElement("link");
    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = url;
    link.id = linkId;
    document.getElementsByTagName("body")[0].appendChild(link);
}

export async function applyTheme(mode = "main") {
    const htmlRoot = document.getElementById("htmlRoot");
    const iframe = document.getElementById("iframe") || null;
    const version = process.env.VUE_APP_VERSION;
    const linkId = `__KFRAME_${mode.toUpperCase()}_THEME_STYLE_${version}`;
    const stylePath = `assets/css/${mode.toLowerCase()}-theme-style.css?${version}`;
    const linkTag = document.getElementById(linkId);
    if (!linkTag) {
        loadStyles(stylePath, linkId);
    }
    if (htmlRoot) {
        htmlRoot.setAttribute("data-theme", mode);
    }
    if (iframe && iframe.contentDocument) {
        const body = iframe.contentDocument.body;
        if (body) {
            body.setAttribute("data-theme", mode);
        }
    }
}

export function isGrayscaleEnabled(skin = {}) {
    return String(skin.__GRAYSCALE__ || "0") === "1";
}

export function applyGrayscale(enabled = false) {
    const htmlRoot = document.getElementById("htmlRoot");
    const body = document.body;
    const value = enabled ? "1" : "0";
    if (htmlRoot) {
        htmlRoot.setAttribute(GRAYSCALE_ATTR, value);
    }
    if (body) {
        body.setAttribute(GRAYSCALE_ATTR, value);
    }
}

export async function getTheme(params = {}) {
    // 使用 axios.create 创建独立实例，避免受全局 baseURL 和拦截器影响
    const instance = axios.create({
        baseURL: "/", // 显式覆盖全局配置的 /api/v1
        timeout: 5000
    });
    try {
        const res = await instance.get("theme/get", { params });
        console.log(res);
        return res.data;
    } catch (error) {
        console.error("获取主题失败:", error);
        return { __THEME_CODE__: "main", __GRAYSCALE__: "0" };
    }
}
